import React, { useEffect, useRef, useState } from 'react'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
// import config from '../../../../config.json'
// import {decryptData} from '../../../../app/modules/auth/components/util';


export function MenuInner() {
//   const salt = process.env.SALT || '6d090796-ecdf-11ea-adc1-0242ac112345';

//   const encryptedclientId = localStorage.getItem('clientId');
//   const clientId = decryptData(encryptedclientId, salt);
//   //const intl = useIntl()
//   const [pointsValue, setPointsValue] = useState<string>('');
//   const [dataFetched, setDataFetched] = useState<boolean>(false); 
//     const fetchPointsData = async () => {
//       try {
//         const url = `${config.apiUrl}/bmpportal/getPoints/${clientId}`;
//         const response = await fetch(url);
//         if (response.ok) {
//           const data = await response.json();
//         if (data.allowanceAvaliable !== undefined && data.totalAllowance) {
//           setPointsValue(data.allowanceAvaliable+'/'+data.totalAllowance);
//           setDataFetched(false);
//         } else {
//           console.error('Unexpected API response:', data);
//         }
//       } else {
//         console.error('Failed to fetch data. Status:', response.status);
//       }
       
    
//   } catch (error) {
//     console.error('Error fetching data:', error);
// }
// };
 
 
//   useEffect(() => {

//     fetchPointsData();

//   }, []);

//   useEffect(() => {
//     // Fetch data from API when the component mounts
//     if (clientId && dataFetched) {
//       fetchPointsDataFromAPI(clientId, setPointsValue);
//       setDataFetched(false);
//     }
//     console.log(pointsValue);
//   }, [pointsValue]);




  return (
  
  //   <div className='d-flex justify-content-center align-items-center'>
  //   <div>
  //     <img alt='Logo' src={toAbsoluteUrl('/media/logos/Bulk_message.svg')} className='h-20px radius-10' />
  //   </div>
  // </div>
<>
<div  className='d-flex justify-content-center align-items-center' style={{ position: "fixed", left: "50%", transform: "translateX(-5%)",marginTop:"20px" }}>
  <img alt='Logo' src={toAbsoluteUrl('/media/logos/Bulk_message.svg')} className='h-20px radius-10' />

</div>
{/*
<div className='d-flex justify-content-center align-items-center' style={{ position: "fixed", left: "50%", transform: "translateX(-5%)", marginTop: "12px", marginLeft: "400px" }}>
  <div
    style={{
      width: "210px",
      height: "40px",
      background: "#F36D2F",
      borderRadius: "32px",
      border: "2px solid #F36D2F",
      color: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0 10px",
    }}
  >
    <i className="bi bi-envelope" style={{ color: "white", fontSize: "15px" }}></i>&nbsp;&nbsp;&nbsp;&nbsp;<div id="pointsDisplayDiv">{pointsValue} Remaining</div>
  </div>
</div>
*/}

</>
  )
}

// export async function fetchPointsDataFromAPI(clientId: string, setPointsValue: React.Dispatch<React.SetStateAction<string>>) {
//   try {
//     const url = `${config.apiUrl}/bmpportal/getPoints/${clientId}`;
//     const response = await fetch(url);
//     if (response.ok) {
//       const data = await response.json();
//       if (data.allowanceAvaliable && data.totalAllowance) {
//         const pointsValue = `${data.allowanceAvaliable}/${data.totalAllowance}`;
//         setPointsValue(pointsValue);
// 	if(document.getElementById("pointsDisplayDiv") != null)
// 	{
// 		document.getElementById("pointsDisplayDiv").innerHTML= pointsValue + " Remaining";
// 	}

//         //alert("setting value");
//       } else {
//         console.error('Unexpected API response:', data);
//       }
//     } else {
//       console.error('Failed to fetch data. Status:', response.status);
//     }
//   } catch (error) {
//     console.error('Error fetching data:', error);
//   }
// }


export default MenuInner;
